import { render, staticRenderFns } from "./netBusinessMain.vue?vue&type=template&id=18b04a06"
import script from "./netBusinessMain.vue?vue&type=script&lang=js"
export * from "./netBusinessMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports